// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"1150411904df89ed","5285":"09d9f3ce2f376e32"}[chunkId] + ".css";
};